import { makeActionCreator } from '../../config/store/utils'

export const SET_TOAST_INFORMATION_SUCCESS = 'SET_TOAST_INFORMATION_SUCCESS'

export const onSetOpenToastSuccess = makeActionCreator(SET_TOAST_INFORMATION_SUCCESS, 'payload')

export const SET_CLOSE_TOAST_SUCCESS = 'SET_CLOSE_TOAST_SUCCESS'

export const onSetCloseToastSuccess = makeActionCreator(SET_CLOSE_TOAST_SUCCESS, 'payload')
